export const BRIEF_CARD_TOP_OFFSET = 8;

export function getBriefScrollTop({
  cardOffsetTop,
  topOffset = BRIEF_CARD_TOP_OFFSET,
}: {
  cardOffsetTop: number;
  topOffset?: number;
}): number {
  return Math.max(0, cardOffsetTop - topOffset);
}

export function findActiveBriefIndex({
  cardOffsetTops,
  scrollTop,
  topOffset = BRIEF_CARD_TOP_OFFSET,
}: {
  cardOffsetTops: number[];
  scrollTop: number;
  topOffset?: number;
}): number {
  const targetScrollTop = scrollTop + topOffset;
  let activeIndex = 0;

  for (let index = 0; index < cardOffsetTops.length; index++) {
    const cardOffsetTop = cardOffsetTops[index];
    if (!Number.isFinite(cardOffsetTop)) {
      break;
    }
    if (cardOffsetTop <= targetScrollTop) {
      activeIndex = index;
      continue;
    }
    break;
  }

  return activeIndex;
}
